import { defineStore } from "pinia";
import * as scoresAPI from "../api/scores-api";
import { IScore } from "@/package/global-types";
import { IScoresStatistics } from "../types/frontend-types";
import { errorHandler } from "@/package/global-helpers/error-handler";

export const useScoresStore = defineStore("scores-store", {
  state: () => ({
    activeScores: [] as Array<IScore>,
    scoresToCreate: [] as Array<IScore>,
    scoreStatistics: null as null | IScoresStatistics,
  }),

  getters: {
    getClientsScoresByCurrency: (state) => {
      return (currency: string) =>
        state.activeScores.filter(
          (score) =>
            score.user_type === "client" &&
            score.currency === currency &&
            !score.is_hidden
        );
    },
    getClientCurrencies: (state) => {
      const scores = state.activeScores.filter(
        (score) => score.account_type !== "yoomoney"
      );
      return () => [...new Set(scores.map((item) => item.currency))];
    },
    getYooMoneyScore: (state) => {
      return () =>
        state.activeScores.find((score) => score.account_type === "yoomoney");
    },
    getClientsHiddenScoresByCurrency: (state) => {
      return (currency: string) =>
        state.activeScores.filter(
          (score) => score.is_hidden && score.currency === currency
        );
    },
    getClientMainScore: (state) => {
      return () => state.activeScores.find((score) => score.is_main);
    },
    getClientMainScores: (state) => {
      return () => state.activeScores.filter((score) => score.can_be_main);
    },
  },

  actions: {
    async loadScores() {
      try {
        const resp = await scoresAPI.apiGetUserScores();
        this.activeScores = resp.data.data.accounts;
        this.scoresToCreate = resp.data.data.accounts_to_create;
        this.scoreStatistics = resp.data.data.stats_main_account;
      } catch (error: Error | unknown) {
        errorHandler(error, true);
        throw error;
      }
    },

    async setMainScore(scoreId: string) {
      try {
        await scoresAPI.apiSetMainScore(scoreId);
        await this.loadScores();
      } catch (error: Error | unknown) {
        errorHandler(error, true);
        throw error;
      }
    },

    async createScore(scoreId: string) {
      try {
        const resp = await scoresAPI.apiCreateUserScore(scoreId);
        return resp.data.data.account;
      } catch (error: Error | unknown) {
        errorHandler(error, true);
        throw error;
      }
    },
  },
});
